import { IMAGES } from "@/lib/content";
import { DON_STORY, STORY_PULL_QUOTE } from "@/lib/story";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";
import { Reveal } from "@/components/site/Reveal";
import { ShareButtons } from "@/components/site/ShareButtons";

export default function OurStory() {
  return (
    <div className="site bg-sage text-pine min-h-screen flex flex-col">
      <Header />
      <main className="flex-1" data-testid="our-story-page">
        <section className="max-w-6xl mx-auto px-6 pt-16 pb-20 grid md:grid-cols-[1.2fr_1fr] gap-12 items-center">
          <div className="min-w-0">
            <p className="lb text-brass-ink fu">Our story · In Don's words</p>
            <h1 className="dp mt-6"><span className="ln"><span>Meet Don</span></span><span className="ln"><span><em>&amp; Lorrie Gramer.</em></span></span></h1>
            <p className="mt-6 max-w-md text-moss fu s1">Cobra gunship pilot in Vietnam. Chief Warrant Officer II. Married to Lorrie for 54 years, with seven children.</p>
          </div>
          <figure className="fu s2 relative aspect-square max-w-md w-full justify-self-center rounded-full overflow-hidden bg-mist-1">
            <img src={IMAGES.founders} alt="Don and Lorrie Gramer" className="absolute inset-0 h-full w-full object-cover object-[50%_35%]" data-testid="our-story-photo" />
          </figure>
        </section>

        <section className="bg-paper py-20 md:py-28">
          <article className="max-w-2xl mx-auto px-6" data-testid="our-story-text">
            {DON_STORY.map((p, i) => (
              <Reveal key={p.slice(0, 24)} as="p" className={`text-lg leading-relaxed ${i ? "mt-6" : ""} ${i === DON_STORY.length - 1 ? "dp !text-3xl" : ""}`}>
                {p}
              </Reveal>
            ))}
            <Reveal as="blockquote" className="mt-14 border-l-2 border-brass pl-6 dp text-3xl leading-snug" data-testid="our-story-quote">
              <em>“{STORY_PULL_QUOTE}”</em>
            </Reveal>
            <div className="mt-12 pt-8 border-t border-pine/15">
              <ShareButtons
                title="Don & Lorrie's story | Military Marriages Matter"
                message="I thought of you when I read Don & Lorrie's story about PTSD, faith and 54 years of marriage:"
                path="/our-story"
                testId="our-story-share"
              />
            </div>
          </article>
        </section>

        <section className="bg-pine text-sage py-20">
          <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-[1.4fr_1fr] gap-8 items-center">
            <h2 className="dp">If this sounds like your home, <em>you're not alone.</em></h2>
            <div className="flex flex-wrap gap-6 items-center">
              <a href="/#book" className="bg-sage text-pine rounded-full px-7 py-4 transition-colors hover:bg-white" data-testid="our-story-book-button">Book a time slot</a>
              <a href="/#prayer" className="underline underline-offset-4 decoration-brass-light" data-testid="our-story-prayer-link">Send a prayer request</a>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
